import { Injectable } from '@angular/core';

const _window = (): any => window;

@Injectable()
export class WindowRef {
    get nativeWindow(): any {
        return _window();
    }
}
